import styled from "styled-components"

export const NutrientChartWrapper = styled.div`
  width: 114px;
  height: 90px;
  position: relative;
  flex-shrink: 0;
  padding: 0 12px;
`

export const NutrientChartCalorieBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NutrientChartCalorie = styled.div`
  font-size: 21px;
  font-weight: 700;
  line-height: 21px;
`
export const NutrientChartCalorieLabel = styled.div`
  color: #fff;
  text-align: center;
  font-size: 15px;
  line-height: 18px;
`

export const NutrientDetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
  justify-content: center;
`

export const NutrientDetailsItemLabel = styled.div<{ $color: string }>`
  font-size: 16px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  line-height: 160%;
`

export const NutrientDetailsItemValue = styled.div`
  font-size: 16px;
  font-style: normal;
  line-height: 120%;
  color: #fff;
  margin-left: auto;
  font-weight: 600;
  line-height: 160%;
`

export const NutrientDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-left: 18px;
`

export const NutrientUnit = styled.span`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-size: 14px;
  line-height: 160%;
  margin-left: 4px;
`
